export default __webpack_public_path__ + "static/media/AI_classic.8a479fc5.jpg";